export default window.Environment || {}
